import React, { useState, useEffect } from 'react'

import { Button, Spinner } from "react-bootstrap"
import { FaChevronDown } from "react-icons/fa"
import { useHistory } from "react-router-dom"
import { MdOutlineRemoveRedEye } from "react-icons/md"
import { FormPreview } from "../../EventDynamicForms/FormPreview"

const FormTab = ({
  selectedForm,
  setSelectedForm,
  handleFormSelect,
  EventID,
  setNewTicket,
  newTicket,
  formsList,
  isLoadingForms,
  errors,
  setErrors,
}) => {
  const history = useHistory()
  const [showFormDropdown, setShowFormDropdown] = useState(false)
  const [currentForm, setCurrentForm] = useState(null)
  const [showForm, setShowForm] = useState("")

  console.log(newTicket, "newTicket", "selectedForm", selectedForm)

  useEffect(() => {
  if (selectedForm && formsList.length > 0) {
    const matched = formsList.find((f) => f.id.toString() === selectedForm.id.toString());
    if (matched) {
      setShowForm(matched.name);
      setCurrentForm(matched);
    } else {
      setShowForm("");
      setCurrentForm(null);
    }
  } else if (newTicket.selected_form && formsList.length > 0) {
    const matched = formsList.find((f) => f.id.toString() === newTicket.selected_form.toString());
    if (matched) {
      setSelectedForm(matched); // ← This line is critical
      setShowForm(matched.name);
      setCurrentForm(matched);
    } else {
      setShowForm("");
      setCurrentForm(null);
    }
  } else {
    setShowForm("");
    setCurrentForm(null);
  }
}, [selectedForm, newTicket.selected_form, formsList, setSelectedForm]);
  const handlePreview = () => {
    const matchedForm = formsList.find(
      (f) => f.id.toString() === (selectedForm?.id || newTicket.selected_form)?.toString(),
    )
    if (matchedForm) {
      setCurrentForm(matchedForm)
    } else {
      console.error("No matching form found for preview!")
    }
  }

  const navigateToDynamicForms = () => {
    history.push("/events/dynamic-forms")
  }

  return (
    <div className="form-tab" style={{ paddingBlock: "24px" }}>
      <div className="mb-4">
        {/* Info Banner */}
        <div
          style={{
            background: "linear-gradient(135deg, #f0f7ff 0%, #e8f2f9 100%)",
            border: "1px solid rgba(24, 71, 120, 0.15)",
            borderRadius: "12px",
            padding: "16px 20px",
            marginBottom: "24px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "36px",
              height: "36px",
              background: "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "14px",
              flexShrink: 0,
              boxShadow: "0 4px 12px rgba(24, 71, 120, 0.2)",
            }}
          >
            <i className=" fa-info-circle" style={{ color: "white", fontSize: "16px" }}></i>
          </div>
          <span style={{ fontSize: "14px", color: "#475569", lineHeight: "1.5" }}>
            Select a registration form that attendees need to fill out to buy this ticket.
          </span>
        </div>

        {/* Form Selection Section */}
        <div className="d-flex align-items-start flex-wrap gap-3">
          <div className="position-relative" style={{ minWidth: "300px", flex: "1" }}>
            <Button
              style={{
                width: "100%",
                background: "white",
                border: `1.5px solid ${errors.selectedForm ? "#ef4444" : "#d1d5db"}`,
                borderRadius: "10px",
                padding: "12px 16px",
                fontSize: "14px",
                fontWeight: "500",
                color: showForm ? "#1a1a1a" : "#9ca3af",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                transition: "all 0.3s ease",
                boxShadow: showFormDropdown ? "0 0 0 3px rgba(24, 71, 120, 0.1)" : "none",
              }}
              onMouseEnter={(e) => {
                if (!showFormDropdown) {
                  e.currentTarget.style.borderColor = errors.selectedForm ? "#ef4444" : "#184778"
                }
              }}
              onMouseLeave={(e) => {
                if (!showFormDropdown) {
                  e.currentTarget.style.borderColor = errors.selectedForm ? "#ef4444" : "#d1d5db"
                }
              }}
              onClick={() => setShowFormDropdown(!showFormDropdown)}
            >
              <span>{showForm || "Select a form"}</span>
              <FaChevronDown
                size={12}
                style={{
                  color: "#6b7280",
                  transform: showFormDropdown ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              />
            </Button>

            {errors.selectedForm && (
              <div
                style={{
                  marginTop: "4px",
                  color: "#ef4444",
                  fontSize: "12px",
                  fontWeight: "500",
                }}
              >
                {errors.selectedForm}
              </div>
            )}

            {showFormDropdown && (
              <div
                style={{
                  position: "absolute",
                  top: "calc(100% + 8px)",
                  left: 0,
                  right: 0,
                  background: "white",
                  border: "1px solid #e5e7eb",
                  borderRadius: "10px",
                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
                  zIndex: 1000,
                  maxHeight: "300px",
                  overflowY: "auto",
                }}
              >
                {isLoadingForms ? (
                  <div
                    style={{
                      padding: "16px 20px",
                      display: "flex",
                      alignItems: "center",
                      color: "#6b7280",
                      fontSize: "14px",
                    }}
                  >
                    <Spinner animation="border" size="sm" style={{ marginRight: "12px" }} />
                    Loading forms...
                  </div>
                ) : formsList.length > 0 ? (
                  formsList.map((form, index) => {
                    const isSelected = (selectedForm?.id || newTicket.selected_form)?.toString() === form.id.toString()
                    return (
                      <div
                        key={form.id}
                        style={{
                          padding: "12px 20px",
                          cursor: "pointer",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: isSelected ? "white" : "#374151",
                          background: isSelected ? "linear-gradient(135deg, #184778 0%, #2563a8 100%)" : "transparent",
                          borderTop: index > 0 ? "1px solid #f3f4f6" : "none",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          if (!isSelected) {
                            e.currentTarget.style.background = "#f9fafb"
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!isSelected) {
                            e.currentTarget.style.background = "transparent"
                          }
                        }}
                        onClick={() => {
                          handleFormSelect(form)
                          setShowForm(form.name)
                          setShowFormDropdown(false)
                          setCurrentForm(form)
                        }}
                      >
                        {form.name}
                      </div>
                    )
                  })
                ) : (
                  <div
                    style={{
                      padding: "16px 20px",
                      color: "#9ca3af",
                      fontSize: "14px",
                      textAlign: "center",
                    }}
                  >
                    No forms available
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Preview Button */}
          {(selectedForm || newTicket.selected_form) && (
            <Button
              style={{
                background: "white",
                border: "1.5px solid #184778",
                borderRadius: "10px",
                padding: "12px 24px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#184778",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#184778"
                e.currentTarget.style.color = "white"
                e.currentTarget.style.transform = "translateY(-2px)"
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(24, 71, 120, 0.25)"
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "white"
                e.currentTarget.style.color = "#184778"
                e.currentTarget.style.transform = "translateY(0)"
                e.currentTarget.style.boxShadow = "none"
              }}
              onClick={handlePreview}
            >
              <MdOutlineRemoveRedEye size={20} />
              Preview
            </Button>
          )}
        </div>

        {/* Edit Form Link */}
        {(selectedForm || newTicket.selected_form) && (
          <div style={{ marginTop: "20px" }}>
            {/* <Button
              variant="link"
              className='btn btn-outline-primary '
            >
              <i className="fas fa-edit" style={{ marginRight: "6px" }}></i>
              Edit form
            </Button> */}
            <p style={{ marginTop: "12px", fontSize: "13px", color: "#64748b", marginBottom: 0 }}>
              This form will be shown to attendees when they register for this ticket.
            </p>
          </div>
        )}
      </div>

      {/* Form Preview Section */}
      {currentForm && (
        <div
          style={{
            marginTop: "32px",
            background: "linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)",
            border: "1px solid #e5e7eb",
            borderRadius: "12px",
            padding: "24px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                width: "36px",
                height: "36px",
                background: "linear-gradient(135deg, #184778 0%, #2563a8 100%)",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "12px",
                boxShadow: "0 4px 12px rgba(24, 71, 120, 0.2)",
              }}
            >
              <MdOutlineRemoveRedEye size={18} color="white" />
            </div>
            <h5
              style={{
                margin: 0,
                fontSize: "18px",
                fontWeight: "600",
                color: "#1a1a1a",
              }}
            >
              Form Preview
            </h5>
          </div>
          <FormPreview
            title={currentForm.form_title || currentForm.name}
            description={currentForm.form_description || currentForm.description || ""}
            fields={currentForm.fields}
            onSubmit={() => alert("Form submitted (preview)")}
            showsubmitButton={false}
          />
        </div>
      )}
    </div>
  )
}

export default FormTab